import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import chapters from "../data/experience.json";
import { profile } from "../data/profile";
import Milestone from "../components/Milestone";
import OverviewText from "../components/OverviewText";
import OverviewLinks from "../components/OverviewLinks";
import "../styles/Overview.scss";
import "../styles/Journey.scss";

function Home() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 600);
    return () => clearTimeout(t);
  }, []);

  return (
    <motion.main
      className="home"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: 0.3 } }}
    >
      <div className="home-topbar">
        <Link to="/" className="home-mark" aria-label="Home">
          {profile.initials}
          <span>©{new Date().getFullYear()}</span>
        </Link>
        <div className="home-status">
          <span className="pulse" aria-hidden="true" />
          {profile.current.role} @ {profile.current.company}
        </div>
      </div>

      <nav className={`journey ${mounted ? "is-journey-mounted" : ""}`} aria-label="Chapters">
        {chapters.map((item) => (
          <Milestone key={item.no} milestone={item.name} no={item.no} />
        ))}
      </nav>

      <div className="overview">
        <OverviewText mounted={mounted} />
        <OverviewLinks />
      </div>
    </motion.main>
  );
}

export default Home;
